// extracted by mini-css-extract-plugin
export default {"NotFullyFilled":"NotFullyFilled_NotFullyFilled__0+UHX","title":"NotFullyFilled_title__QEPkF","btnred":"NotFullyFilled_btnred__oov3g","galka":"NotFullyFilled_galka__VS3TT"};